import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_DAILY_FLOW,
  GET_DT_DAILY_FLOW_COLUMN,
  GET_DT_DAILY_FLOW_PLAN,
  SAVE_DT_DAILY_FLOW,
  SAVE_DT_DAILY_FLOW_COLUMN,
  SAVE_DT_DAILY_FLOW_PLAN,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

let itemChanged = [];
let originalModelList = [];
// console.log(itemChanged)

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number))
    return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}
function DailyFlow(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [AVGObject, setAVGObject] = useState({mode:'AVG'});
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [columnDataList, setColumnDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [planModelList, setPlanModelList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
      },
      formatter: CountIndexRow,
    },
  ]);
  const [columnRenderPlanList, setColumnRenderPlanList] = useState([
    {
      dataField: "DAILYFLOW_MONTH",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "DAILYFLOWPLAN_DATA",
      text: "Flow/Fuel Target",
      headerAlign: "center",
      editable: true,
      align: "center",
      headerStyle: {
        backgroundColor: "rgb(100 120 215)",
      },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
  ]);
  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.dateSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "2px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };
  const compareOriginalData = (value, other) => {
    // Get the value type
    var type = Object.prototype.toString.call(value);
    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false;

    // If items are not an object or array, return false
    if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false;

    // Compare the length of the length of the two items
    var valueLen =
      type === "[object Array]" ? value.length : Object.keys(value).length;
    var otherLen =
      type === "[object Array]" ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    // Compare two items
    var compare = function (item1, item2) {
      // Get the object type
      var itemType = Object.prototype.toString.call(item1);

      // If an object or array, compare recursively
      if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
        if (!compareOriginalData(item1, item2)) return false;
      }

      // Otherwise, do a simple comparison
      else {
        if (itemType === "[object Function]") {
          if (item1.toString() !== item2.toString()) return false;
        } else {
          if (item1 != item2) return false;
        }
      }
    };

    // Compare properties
    if (type === "[object Array]") {
      for (var i = 0; i < valueLen; i++) {
        if (compare(value[i], other[i]) === false) itemChanged.push(other[i]);
      }
    } else {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          if (compare(value[key], other[key]) === false) return false;
        }
      }
    }

    return true;
  };
  const addHeaderTable = () => {
    let prevHeader = document.getElementById(
      "dialyflow-gas-volume-table-header"
    );
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("dialyflow-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="dialyflow-gas-volume-table-header" colspan="' +
      (columnDataList.length + 1) +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Month Flow</th>';
    thead.prepend(tr);
  };
  const getColumn = () => post(GET_DT_DAILY_FLOW_COLUMN, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        DAILYFLOWCOLUMN_ORDER: columnManageList.length + 1,
        DAILYFLOWCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        GMDRTAG_NAME: "",
        DAILYFLOWCOLUMN_DESC: "",
        DAILYFLOWCOLUMN_TYPE: "",
        DAILYFLOWCOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 },
      },
    ]);
  };
  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.DAILYFLOWCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row =>
            row.DAILYFLOWCOLUMN_NAME == "" || row.DAILYFLOWCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        let res = await post(SAVE_DT_DAILY_FLOW_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const formatNumber = (cellContent, row) => {
    return <div>{numberFormat(cellContent, 2)}</div>;
  };

  const generateRow = () => {
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    function getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push({
          date: moment(new Date(date)).format("D"),
          DAILYFLOW_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          DAILYFLOW_MONTH: new Date(date).getDate(),

          PID: "",
          DAILYFLOWPLAN_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          DAILYFLOWPLAN_MONTH: new Date(date).getDate(),
          DAILYFLOWPLAN_DATA: 0,
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    }

    let currentDate = addDays(new Date(), -1);
    let startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    let dayList;
    let dateDiff = currentDate.getDate() - startDate.getDate() + 1;

    if (
      props.dateSelected &&
      (props.dateSelected.getFullYear() < currentDate.getFullYear() ||
        (props.dateSelected.getMonth() < currentDate.getMonth() &&
          props.dateSelected.getFullYear() == currentDate.getFullYear()))
    ) {
      dayList = getDaysInMonth(
        props.dateSelected.getMonth(),
        props.dateSelected.getFullYear()
      );
    } else {
      dayList = getDaysInMonth(
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      dayList = dayList.slice(0, dateDiff);
    }
    let dayListModelList = addFieldToModelDeviceList(dayList);
    originalModelList = addFieldToModelDeviceList(dayList);
    setModelDeviceList(dayListModelList);
  };
  const calculateAVG = () => {
    let planAvg =
      modelDeviceList.reduce(
        (a, b) => a + parseFloat(b.DAILYFLOWPLAN_DATA),
        0
      ) / modelDeviceList.length;
    let avgObj = { mode:"AVG",date: "AVG", DAILYFLOWPLAN_DATA: planAvg };
    columnDataList.map(collumn => {
      let sum = 0;
      modelDeviceList.map(object => {
        sum += object[collumn.DAILYFLOWCOLUMN_NAME];
      });
      avgObj[collumn.DAILYFLOWCOLUMN_NAME] = sum / modelDeviceList.length;
    });
    setAVGObject(avgObj);
  };
  useEffect(() => {
    calculateAVG();
  }, [modelDeviceList]);
  const generatePlanRow = () => {
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    function getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push({
          date: moment(new Date(date)).format("D"),
          DAILYFLOW_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          DAILYFLOW_MONTH: new Date(date).getDate(),
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
    let currentDate = addDays(new Date(), -1);
    let startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    let dayList;
    let dateDiff = currentDate.getDate() - startDate.getDate() + 1;

    if (
      props.dateSelected &&
      props.dateSelected.getMonth() < currentDate.getMonth()
    ) {
      dayList = getDaysInMonth(
        props.dateSelected.getMonth(),
        props.dateSelected.getFullYear()
      );
    } else {
      dayList = getDaysInMonth(
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      dayList = dayList.slice(0, dateDiff);
    }
    dayList = addFieldToPlanList(dayList);
    setPlanModelList(dayList);
  };
  const renderColumn = () => {
    setColumnRenderList([
      {
        dataField: "DAILYFLOW_MONTH",
        text: "Date",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#7E8EDA",
          width: "70px",
        },
        style: { width: "70px" },
        formatter: CountIndexRow,
      },
      {
        dataField: "DAILYFLOWPLAN_DATA",
        text: "Flow/Fuel Target",
        headerAlign: "center",
        editable: true,
        align: "center",
        formatter: formatNumber,
        headerStyle: {
          backgroundColor: "rgb(100 120 215)",
          width: "115px",
        },
        editorStyle: () => {
          return { height: "25px" };
        },
        style: { width: "115px", cursor: "pointer" },
        validator: (newValue, row, column, done) => {
          setTimeout(() => {
            if (isNaN(newValue)) {
              return done({
                valid: false,
                message: "Should be numeric",
              });
            }
            return done();
          }, 0);
          return {
            async: true,
          };
        },
      },
      {
        dataField: "",
        text: "",
        headerAlign: "center",
        editable: false,
        align: "center",
        isDummy: true,
        headerStyle: {
          width: "30px",
        },
        style: { width: "30px" },
        headerClasses: "hidden-column",
        classes: "hidden-column",
      },
      {
        dataField: "date",
        text: "Date",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: colorOption[0].label,
          width: "30px",
        },
        style: { width: "30px" },
      },
      ...columnDataList
        .sort((a, b) =>
          a.DAILYFLOWCOLUMN_ORDER > b.DAILYFLOWCOLUMN_ORDER
            ? 1
            : b.DAILYFLOWCOLUMN_ORDER > a.DAILYFLOWCOLUMN_ORDER
            ? -1
            : 0
        )
        .filter(
          obj =>
            obj.DAILYFLOWCOLUMN_SHOW == true ||
            obj.DAILYFLOWCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.DAILYFLOWCOLUMN_NAME.replaceAll(".", "_"),
          text: obj.DAILYFLOWCOLUMN_NAME,
          headerAlign: "center",
          formatter: formatNumber,
          editable: true,
          align: "center",
          editorStyle: () => {
            return { height: "25px" };
          },
          headerStyle: {
            backgroundColor: colorOption[obj.DAILYFLOWCOLUMN_TYPE].label,
            width: "100px",
          },
          style: { width: "100px", cursor: "pointer" },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = "";
            if (obj.STATUS_FLAG != 0) className += "from-source";
            if (obj.STATUS_FLAG == 1 || obj.STATUS_FLAG == 3)
              className += " pmis";
            return className;
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
    ]);
  };
  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtDailyFlowColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.DAILYFLOWCOLUMN_TYPE],
          show:
            obj.DAILYFLOWCOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
          source:
            obj.STATUS_FLAG == 0
              ? { label: "Manual", value: 0 }
              : obj.STATUS_FLAG == 1
              ? { label: "Scada", value: 1 }
              : { label: "Flow Selection", value: 2 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    itemChanged = [];
    compareOriginalData(
      originalModelList.filter(row => row.PID != ""),
      modelDeviceList.filter(row => row.PID != "")
    );
    let dataEdited = [
      ...itemChanged,
      ...modelDeviceList.filter(row => row.PID == ""),
    ];
    // console.log(dataEdited)
    try {
      let data = [];
      let planData = [];
      dataEdited.map(obj => {
        let {
          PID,
          DAILYFLOWPLAN_DATE,
          DAILYFLOWPLAN_MONTH,
          DAILYFLOWPLAN_DATA,
          PRIORITY_FLAG,
          STATUS_FLAG,
        } = obj;
        planData.push({
          PID,
          DAILYFLOWPLAN_DATE,
          DAILYFLOWPLAN_MONTH,
          DAILYFLOWPLAN_DATA,
          PRIORITY_FLAG,
          STATUS_FLAG,
        });
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
              `${objColumn.DAILYFLOWCOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            DAILYFLOWACTUAL_DATA:
              obj[objColumn.DAILYFLOWCOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      //   console.log(planModelList,data)
      let [res1, res2] = await Promise.all([
        post(SAVE_DT_DAILY_FLOW, data),
        post(SAVE_DT_DAILY_FLOW_PLAN, planData),
      ]);
      // console.log(res1);
      // console.log(res2);
      if (res1.resultCode != 200) {
        dispatch(messageAction.showMessage(res1.resultDescription));
      } else if (res2.resultCode != 200) {
        dispatch(messageAction.showMessage(res2.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      // generateRow();
      let column = await getColumn();
      setColumnDataList(
        column.data.dtDailyFlowColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let [res1, res2] = await Promise.all([
        post(GET_DT_DAILY_FLOW, {
          DAILYFLOW_MONTHYEAR: moment(props.dateSelected).format("YYYY-MM-01"),
        }),
        post(GET_DT_DAILY_FLOW_PLAN, {
          DAILYFLOWPLAN_MONTHYEAR: moment(props.dateSelected).format(
            "YYYY-MM-01"
          ),
        }),
      ]);

      setPlanList(res2.data.dtDailyFlowPlanList);
      setDataList(res1.data.dtDailyFlowList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    //fixed header table
    let tableId = "dialyflow-tab-table";
    let scrollY = 203;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        for (var i = 0; i < tr.childNodes.length; i++) {
          th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document
        .querySelector(`#vertical-menu-btn`)
        ?.removeEventListener("click", resizeTableHeader);
    };
    //fixed header table
  }, []);
  useEffect(() => {
    generateRow();
    // generatePlanRow();
  }, [dataList]);
  useEffect(() => {
    fetchData();
  }, [props.dateSelected]);
  useEffect(() => {
    renderColumn();
    // addHeaderTable();
    if (columnDataList.length > 1) {
      generateRow();
      // generatePlanRow()
    }
  }, [columnDataList]);
  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      DAILYFLOW_DATE: "",
      DAILYFLOWCOLUMN_PID: "",
      DAILYFLOWCOLUMN_ORDER: 0,
      DAILYFLOWCOLUMN_NAME: "",
      DAILYFLOW_MONTH: 0,
      DAILYFLOWACTUAL_DATA: 0,
      SOURCE_PID: null,
      SOURCE_NAME: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };

    if (rowList.length > 0) {
      let data = dataList;
      let modelList = [];
      columnDataList.map(objColumn => {
        // console.log(objColumn)
        modelList = rowList.map(obj => {
          let plan = planList.find(
            value =>
              obj.DAILYFLOWPLAN_MONTH == value.DAILYFLOWPLAN_MONTH &&
              obj.DAILYFLOWPLAN_DATE ==
                moment(value.DAILYFLOWPLAN_DATE).format("YYYY-MM-DD")
          );
          let value = data.find(
            value =>
              value.DAILYFLOWCOLUMN_PID == objColumn.PID &&
              value.DAILYFLOW_MONTH == obj.DAILYFLOW_MONTH
          );

          obj[objColumn.DAILYFLOWCOLUMN_NAME.replaceAll(".", "_")] = value
            ? value.DAILYFLOWACTUAL_DATA
            : 0;
          obj[`${objColumn.DAILYFLOWCOLUMN_NAME.replaceAll(".", "_")}__data`] =
            {
              ...dataModel,
              ...value,
              DAILYFLOW_DATE: obj.DAILYFLOW_DATE,
              DAILYFLOW_MONTH: obj.DAILYFLOW_MONTH,
              DAILYFLOWCOLUMN_PID: objColumn.PID,
              DAILYFLOWCOLUMN_ORDER: objColumn.DAILYFLOWCOLUMN_ORDER,
              DAILYFLOWCOLUMN_NAME: objColumn.DAILYFLOWCOLUMN_NAME,
            };
          return { ...obj, month: obj.month, ...plan };
        });
      });
      // console.log(modelList)
      return modelList;
    }
  };
  const addFieldToPlanList = rowList => {
    let dataModel = {
      PID: "",
      DAILYFLOWPLAN_DATE: "",
      DAILYFLOWPLAN_MONTH: 0,
      DAILYFLOWPLAN_DATA: 0,
    };
    if (rowList.length > 0) {
      let modelList = [];
      let data = planList;
      modelList = rowList.map(obj => {
        let value = data.find(
          value =>
            moment(value.DAILYFLOWPLAN_DATE).format("YYYY-MM-DD") ==
            moment(obj.DAILYFLOW_DATE).format("YYYY-MM-DD")
        );

        if (value) {
          dataModel.DAILYFLOWPLAN_DATA = value.DAILYFLOWPLAN_DATA;
          dataModel.PID = value.PID;
        }
        return {
          ...dataModel,
          date: obj.date,
          DAILYFLOWPLAN_DATE: obj.DAILYFLOW_DATE,
          DAILYFLOWPLAN_MONTH: obj.DAILYFLOW_MONTH,
        };
      });
      //   console.log(modelList)
      return modelList;
    }
  };
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  DAILYFLOWCOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...(isFocused && { backgroundColor: "#2E3460" }),
    }),
  };

  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  DAILYFLOWCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManage = [
    {
      dataField: "DAILYFLOWCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor: "pointer",
      },
      type: "number",
    },

    {
      dataField: "DAILYFLOWCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Source",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: [
    //       {
    //         value: 0,
    //         label: "Manual",
    //       },
    //       {
    //         value: 1,
    //         label: "SCADA",
    //       },
    //       {
    //         value: 2,
    //         label: "Flow Selection",
    //       },
    //       {
    //         value: 3,
    //         label: "GMDR",
    //       },
    //     ],
    //   },
    //   formatter: (cell, row, rowIndex) =>
    //     row.STATUS_FLAG == 0
    //       ? "Manual"
    //       : row.STATUS_FLAG == 1
    //       ? "SCADA"
    //       : row.STATUS_FLAG == 2
    //       ? "Flow Selection"
    //       : "GMDR",
    // },
    // {
    //   dataField: "SCADATAG_NAME",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    {
      dataField: "DAILYFLOWCOLUMN_DESC",
      text: "Description",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor: "pointer",
      },
    },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColor,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end mt-2 ">
          {permission.mMIM && (
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => handleShowManageColumn()}
            >
              <i className="bx bx-columns"></i>&nbsp; Manage Column Flow/Fuel (
              Daily )
            </button>
          )}

          {permission.eFFO && (
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={handleSaveData}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
          )}
        </div>
        <div className="mt-2 row">
          {/* <div className="col">
            <BootstrapTable
              id="dialyflowplan-tab-table"
              keyField="date"
              data={planModelList}
              columns={columnRenderPlanList}
              rowStyle={rowStyle}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            />
          </div> */}

          <div className="col">
            <BootstrapTable
              id="dialyflow-tab-table"
              keyField="date"
              data={modelDeviceList}
              columns={columnRenderList}
              rowStyle={rowStyle}
              wrapperClasses={"hidden-column"}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                onStartEdit: (oldValue, newValue, row, column) => {
                  $("#dialyflow-tab-table .form-control.editor.edit-text").bind(
                    "enterKey",
                    function (e) {
                      let cell = $(this).parent().next();
                      setTimeout(() => {
                        cell.click();
                      }, 50);
                    }
                  );
                  $(
                    "#dialyflow-tab-table .form-control.editor.edit-text"
                  ).keypress(function (e) {
                    if (e.keyCode == 13) {
                      $(this).trigger("enterKey");
                    }
                  });
                },
                afterSaveCell: (oldValue, newValue, row, column) => {
                  calculateAVG();
                  // console.log(column);
                },
              })}
            />
            <BootstrapTable
              id="dialyflow-tab-avg-table"
              keyField="mode"
              data={[AVGObject]}
              columns={[
                {
                  dataField: "mode",
                  text: "",
                  headerAlign: "center",
                  editable: false,
                  align: "center",
                  headerStyle: {
                    backgroundColor: "#7E8EDA",
                    width: "70px",
                  },
                  style: { width: "70px" },
                },
                ...columnRenderList.filter((row, index) => index != 0),
              ]}
              rowStyle={rowStyle}
              wrapperClasses={"hidden-column mt-4"}
              headerClasses="header-style hide"
            />
          </div>
        </div>
      </Col>
      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Daily Flow/Fuel Oil</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-dialyflow-table"
            keyField="ROW"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(column);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "DAILYFLOWCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default DailyFlow;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

DailyFlow.propTypes = {
  dateSelected: PropTypes.any,
};
